import React, { Component } from "react";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import { toast } from "../../../utils/helpers";
import Loader from "../../general/Loader";

export default class TicketsForm extends Component {
    state = {
        saving: false,
        pesoBruto: "",
        pesoTara: 0,
        pesoNeto: 0,
        hora: "",
        cambiarDigitacion: false,
        soloChofer: false,
        nota: '',
        errors: {}
    };
    createTicket = async event => {
        event.preventDefault();

        this.setState({ saving: true });

        const { programacion, tarjeta } = this.props;
        const token = auth.getToken();
        const data = new FormData(event.target);

        const url = `programaciones/${programacion}/tarjetas/${tarjeta}/tickets`;

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token
            }
        });

        const response = await res.json();

        if (response.success) {
            this.props.getProgramacion();
            this.setState({
                pesoBruto: "",
                pesoTara: 0,
                pesoNeto: 0,
                hora: "",
                soloChofer: false,
            });
            document.getElementById("numeroInput").focus();
            document.getElementById("ticketForm").reset();
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });

            if (response.data.message.numero) {
                toast("Este ticket ya ha sido registrado.", "error");
            }
        }

        this.setState({ saving: false });
    };
    onInputChange = (e, nombre) => {
        this.setState({
            [nombre]: e.target.value
        });
    };
    onPesoChange = (e, nombre) => {
        const input = nombre === "pesoNeto" ? "pesoTara" : "pesoNeto";
        this.setState({
            [input]: this.state.pesoBruto - e.target.value,
            [nombre]: e.target.value
        });
    };
    onHoraChange = e => {
        let string = e.target.value;

        if (string.length > 5) return;

        string = string
            .replace(/:/g, "")
            .replace(/(2[0-3]|[0-1]?[0-9])([0-5][0-9])([0-9]*)/g, "$1:$2");
        this.setState({
            hora: string
        });
    };
    render() {
        const {
            pesoBruto,
            pesoTara,
            pesoNeto,
            hora,
            cambiarDigitacion,
            soloChofer,
            nota,
        } = this.state;
        return (
            <div className='tickets-form'>
                <label>
                    <input
                        type='checkbox'
                        onChange={e =>
                            this.setState({
                                cambiarDigitacion: e.target.checked
                            })
                        }
                        checked={cambiarDigitacion}
                        style={{
                            marginRight: "7px",
                            verticalAlign: "-2px"
                        }}
                    />
                    Cambiar Digitación
                </label>
                <label>
                    <input
                        type='checkbox'
                        onChange={e =>
                            this.setState({
                                soloChofer: e.target.checked
                            })
                        }
                        checked={soloChofer}
                        style={{
                            marginRight: "7px",
                            verticalAlign: "-2px"
                        }}
                    />
                    Solo al chofer
                </label>
                <form
                    id='ticketForm'
                    method='post'
                    onSubmit={this.createTicket}>
                    <input type='hidden' name='_method' value='post' />
                    <input type='hidden' name='solo_chofer' value={soloChofer} />
                    <table className='table'>
                        <tbody>
                            <tr>
                                <td>
                                    <div className='form-group'>
                                        <input
                                            type='text'
                                            name='numero'
                                            className='form-control'
                                            id='numeroInput'
                                        />
                                        <label>Número</label>
                                    </div>
                                </td>
                                <td>
                                    <div className='form-group'>
                                        <input
                                            type='text'
                                            name='hora'
                                            value={hora}
                                            onChange={this.onHoraChange}
                                            pattern='(2[0-3]|[0-1]?[0-9]):([0-5][0-9])'
                                            className='form-control'
                                        />
                                        <label>Hora</label>
                                    </div>
                                </td>
                                <td>
                                    <div className='form-group'>
                                        <input
                                            type='number'
                                            name='peso_bruto'
                                            onChange={e =>
                                                this.onInputChange(
                                                    e,
                                                    "pesoBruto"
                                                )
                                            }
                                            value={pesoBruto}
                                            step='0.01'
                                            min='0'
                                            className='form-control'
                                        />
                                        <label>Peso Bruto</label>
                                    </div>
                                </td>
                                {!cambiarDigitacion ? (
                                    <td>
                                        <div className='form-group'>
                                            <input
                                                type='number'
                                                onChange={e =>
                                                    this.onPesoChange(
                                                        e,
                                                        "pesoTara"
                                                    )
                                                }
                                                value={pesoTara}
                                                name='peso_tara'
                                                step='0.01'
                                                min='0'
                                                max={pesoBruto}
                                                className='form-control'
                                            />
                                            <label>Peso Tara</label>
                                        </div>
                                    </td>
                                ) : (
                                    <td>
                                        <div className='form-group'>
                                            <input
                                                type='number'
                                                onChange={e =>
                                                    this.onPesoChange(
                                                        e,
                                                        "pesoNeto"
                                                    )
                                                }
                                                value={pesoNeto}
                                                name='peso_neto'
                                                step='0.01'
                                                min='0'
                                                className='form-control'
                                            />
                                            <label>Peso Neto</label>
                                        </div>
                                    </td>
                                )}
                                {!cambiarDigitacion ? (
                                    <td>
                                        <div
                                            className='form-group'
                                            style={{ width: 90 }}>
                                            <input
                                                type='hidden'
                                                name='peso_neto'
                                                value={pesoNeto}
                                                className='form-control'
                                            />
                                            <div className='p-t-5 p-b-5'>
                                                {pesoNeto}
                                            </div>
                                            <label style={{ marginTop: 3 }}>
                                                Peso Neto
                                            </label>
                                        </div>
                                    </td>
                                ) : (
                                    <td>
                                        <div
                                            className='form-group'
                                            style={{ width: 90 }}>
                                            <input
                                                type='hidden'
                                                name='peso_tara'
                                                value={pesoTara}
                                                className='form-control'
                                            />
                                            <div className='p-t-5 p-b-5'>
                                                {pesoTara}
                                            </div>
                                            <label style={{ marginTop: 3 }}>
                                                Peso Tara
                                            </label>
                                        </div>
                                    </td>
                                )}
                                <td>
                                {!soloChofer && (
                                    <div className='form-group'>
                                        {this.state.saving ? (
                                            <Loader type='small' />
                                        ) : (
                                            <button
                                                type='submit'
                                                className='btn btn-primary'>
                                                <i className='fas fa-plus' />
                                            </button>
                                        )}
                                    </div>
                                )}
                                </td>
                            </tr>
                            {soloChofer && (
                                <tr>
                                    <td colSpan="5">
                                        <textarea className="form-control" name="nota" rows="4">{nota}</textarea>
                                        <label>Nota</label>
                                    </td>
                                    <td>
                                        <div className='form-group'>
                                            {this.state.saving ? (
                                                <Loader type='small' />
                                            ) : (
                                                <button
                                                    type='submit'
                                                    className='btn btn-primary'>
                                                    <i className='fas fa-plus' />
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </form>
            </div>
        );
    }
}
